import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, makeStyles, Option } from "@fluentui/react-components";
import { Mic20Filled } from "@fluentui/react-icons";

const useStyles = makeStyles({
  label: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
});

export function PreferredMicSelect({ isMicEnabled, microphoneOptions, onMicrophoneChange }) {
  const preferredMicValue = microphoneOptions.value;
  const preferredMicLabel = microphoneOptions.options?.find(option => option.value === preferredMicValue)?.label;
  const microphoneOptionsOptions = microphoneOptions.options;
  const styles = useStyles();

  return (
    <Dropdown
      placeholder="-"
      onOptionSelect={(_, data) => onMicrophoneChange(data.optionValue)}
      appearance="filled-darker"
      disabled={!isMicEnabled}
      button={
        <span className={styles.label}>
          <Mic20Filled />
          &nbsp;
          {preferredMicLabel}
        </span>
      }
      selectedOptions={[preferredMicValue]}
      value={preferredMicLabel}
    >
      {microphoneOptionsOptions &&
        microphoneOptionsOptions.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            <span className={styles.label}>{option.label}</span>
          </Option>
        ))}
    </Dropdown>
  );
}

PreferredMicSelect.propTypes = {
  microphoneOptions: PropTypes.shape({
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired,
  onMicrophoneChange: PropTypes.func.isRequired,
  isMicEnabled: PropTypes.bool.isRequired,
  selectedMicrophoneOptions: PropTypes.arrayOf(PropTypes.string)
};
